module.exports = __webpack_public_path__ + "img/2c89ad0.jpg";